/** Fired after a product review is saved so PDP can refetch ratings-meta. */
export const PRODUCT_REVIEW_SUBMITTED = 'productReviewSubmitted';

export function notifyProductReviewSubmitted(productId) {
    if (!productId) return;
    window.dispatchEvent(
        new CustomEvent(PRODUCT_REVIEW_SUBMITTED, {
            detail: { productId: String(productId) },
        })
    );
}
